export default __webpack_public_path__ + "static/media/812.81f0ab93.gif";